'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX, ReactNode } from 'react';
import { howItWorksStepCardClass } from '@/components/support-mainnet/how-it-works/how-it-works-step-card-layout';
import { type HowItWorksStepIndex, useHowItWorksRequestStepPlayback } from '@/components/support-mainnet/how-it-works/how-it-works-step-playback-api';
import { cn } from '@/lib/ui/utils';
export function HowItWorksStepCardShell(t0) {
  const $ = _c(10);
  const {
    stepIndex,
    testId,
    className,
    children
  } = t0;
  const requestStepPlayback = useHowItWorksRequestStepPlayback();
  let t1;
  if ($[0] !== className) {
    t1 = cn(howItWorksStepCardClass, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== requestStepPlayback || $[3] !== stepIndex) {
    t2 = () => {
      requestStepPlayback(stepIndex);
    };
    $[2] = requestStepPlayback;
    $[3] = stepIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t2 || $[8] !== testId) {
    t3 = <article data-testid={testId} className={t1} onPointerEnter={t2}>{children}</article>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
    $[8] = testId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}